<template>
    <!-- Video Instruction Popup -->
    <HintVideo v-if="!pageMode && !isTgApp" />
    <!-- Start Popup -->
    <HintStartPopup v-if="!pageMode && isTgApp" />
</template>


<script>
import HintVideo from '@/components/widgets/HintVideo.vue'
import HintStartPopup from '@/components/widgets/HintStartPopup.vue'

export default {
    name: 'Popups',
    components: {
        HintVideo,
        HintStartPopup
    },
    data() {
        return {

        }
    },
    computed: {
        screenSize() { return this.$store.getters.StateScreenSize },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        isLoggedIn: function () { return this.$store.getters.isAuthenticated },
        pageMode: function () {
            try { return this.$route.meta.pageMode } 
            catch { return false }
        },
    },
}
</script>